export default {"src":"/_next/static/media/black-dimensional-chain.b20e6924.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};